import angular from 'angular';
import Login from './login/login';
import Dashboard from './dashboard/dashboard';
import Profile from './profile/profile';
import Shop from './shop/shop';
import Store from './store/store';
import Faq from './faq/faq';
import Taxation from './taxation/taxation';
import Services from './services/services';
import Checkin from './checkin/checkin';
import Menu from './menu/menu';
import LoginSuperAdmin from './loginSuperAdmin/loginSuperAdmin';
import ListaMerchantSuperAdmin from './listaMerchantSuperAdmin/listaMerchantSuperAdmin';
import MessageOutbound from './messageOutbound/messageOutbound';
import Logout from './logout/logout';
import Sca from './sca/sca'

const componentModule = angular.module('tinaba.components', [
  Login.name,
  Dashboard.name,
  Shop.name,
  Store.name,
  Profile.name,
  Services.name,
  Faq.name,
  Taxation.name,
  Checkin.name,
  Menu.name,
  LoginSuperAdmin.name,
  ListaMerchantSuperAdmin.name,
  MessageOutbound.name,
  Logout.name,
  Sca.name
]);

export default componentModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/components.js
 **/